import React from 'react';

const modalStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(30,41,59,0.6)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
};

const contentStyle = {
  background: 'var(--cc-card-bg)',
  borderRadius: '12px',
  padding: '32px',
  minWidth: '350px',
  maxWidth: '90vw',
  boxShadow: '0 8px 40px rgba(0,0,0,0.15)',
};

const TeamSetupModal = ({ open, onClose, children }) => {
  if (!open) return null;
  return (
    <div style={modalStyle} onClick={onClose}>
      <div style={contentStyle} onClick={e => e.stopPropagation()}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 24,
            right: 32,
            background: 'none',
            border: 'none',
            fontSize: 24,
            cursor: 'pointer',
            color: 'var(--cc-text-muted)'
          }}
          aria-label="Close"
        >×</button>
        {children}
      </div>
    </div>
  );
};

export default TeamSetupModal;